import { createContext, useContext } from 'react';

/**
 * A MESMA TRIAGEM, FORA DO MODAL (Douglas 22/09/2026).
 *
 * A página Triagens mostra a fila ao lado da lista, em vez de abrir um modal
 * por cima do Kanban. Em vez de tocar nos 18 componentes de triagem — cada um
 * com a sua assinatura — quem decide a moldura é este contexto: a página o
 * liga, o TriagemShell o lê, e nenhuma triagem precisa saber onde está sendo
 * desenhada. No Kanban nada muda: sem provedor, o valor é false.
 */
export const TriagemEmbutidaContext = createContext(false);
export const useTriagemEmbutida = () => useContext(TriagemEmbutidaContext);
